import Vue from 'vue'
import {
  Button,
  Cell,
  CellGroup,
  Field,
  Icon,
  Tabs,
  Tab,
  NavBar,
  Tag,
  List,
  Toast,
  Dialog,
  Notify,
  PullRefresh,
  Popup,
  Loading,
  Search,
  Picker
} from 'vant'

Vue.use(Button)
Vue.use(Cell).use(CellGroup)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Tabs).use(Tab)
Vue.use(NavBar)
Vue.use(Tag)
Vue.use(List)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Notify)
Vue.use(PullRefresh)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(Search)
Vue.use(Picker)
